<mat-card class="sub-section">
  <mat-card-header>
    <mat-card-title>{{ 'performance.winRatesByCntEst.title' | translate }}</mat-card-title>
    <mat-card-subtitle>
      <p>{{ 'performance.winRatesByCntEst.subTitle' | translate }}</p>
      <ul>
        <li>{{ 'performance.winRatesByCntEst.description.win' | translate }}</li>
        <li>{{ 'performance.winRatesByCntEst.description.error' | translate }}</li>
      </ul>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <div class="table-scroll-container full-height-table">
      <table
        class="win-rates-table"
        mat-table
        [dataSource]="dataSource"
        (matSortChange)="sortChange($event)"
        matSort
        matSortStart="desc"
        [matSortActive]="orderBy"
        [matSortDirection]="orderDirection"
      >
        <ng-container matColumnDef="numberOfSell">
          <th mat-header-cell class="no-border" *matHeaderCellDef>
            {{ 'performance.winRatesByCntEst.table.numberOfSell' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <span>
              {{ element.cntEstFrom | compactNumber: lang() : '' : false }}
              @if (element.cntEstTo) {
                <span>-</span>
              }
              {{
                element.cntEstTo
                  | compactNumber
                    : lang()
                    : ((element.cntEstFrom ? 'performance.numFromTo.greater' : '') | translate)
                    : false
              }}
            </span>
          </td>
          <td mat-footer-cell *matFooterCellDef>
            {{ 'performance.numFromTo.total' | translate }}
          </td>
        </ng-container>

        @for (column of ANALYST_COVERAGE_COLUMNS; track column) {
          <ng-container [matColumnDef]="column.name">
            <th mat-header-cell mat-sort-header class="no-border" [ngClass]="column.classes" *matHeaderCellDef>
              {{ column.i18nName | translate }}
            </th>
            <td mat-cell *matCellDef="let element" [ngClass]="column.classes">
              <span>
                {{ column.prefix }}{{ column.title ? '' : get(element, column.key)
                }}{{ column.title ? (column.title(get(element, column.key)) | translate) : '' }}{{ column.postfix }}
              </span>
            </td>
            <td mat-footer-cell *matFooterCellDef [ngClass]="column.classes">
              <span>
                {{ column.prefix }}{{ column.title ? '' : getTotalValue(column.key)
                }}{{ column.title ? (column.title(getTotalValue(column.key)) | translate) : '' }}{{ column.postfix }}
              </span>
            </td>
          </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="DISPLAYED_COLUMNS"></tr>
        <tr mat-row *matRowDef="let row; columns: DISPLAYED_COLUMNS"></tr>
        <tr mat-footer-row *matFooterRowDef="DISPLAYED_COLUMNS"></tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>
